/**
 * ============================================================================
 * PUBLIC ROUTE COMPONENT - Redirects Authenticated Users
 * ============================================================================
 * 
 * Public routes that redirect authenticated users to dashboard
 */

import { Navigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { ROUTES } from '../../utils/constants';

/**
 * PublicRoute Component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render
 * @returns {JSX.Element}
 */
const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  
  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }
  
  return children;
};

export default PublicRoute;
